import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import Invoice from "../pages/Invoice";
import ProtectedRouteV2 from "./ProtectedRouteV2";

const invoiceRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/invoice"
      element={
        <>
          <PageTitle title="Invoice | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <Invoice />
        </>
      }
    />
  </Route>
);

export default invoiceRoutes;
